module.exports = __webpack_public_path__ + "img/watch-movies.b2e24c23.svg";